export interface IconProps {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  size?: number;
  filled?: boolean;
}

/**
 * Renders a Google Material Symbols Rounded icon.
 * Pass the Material Symbols ligature name (e.g., "search", "check_circle", "star").
 */
export function Icon({ name, className, style, size, filled }: IconProps) {
  return (
    <span
      className={`material-symbols-rounded${className ? ` ${className}` : ''}`}
      style={{
        ...style,
        ...(size ? { fontSize: `${size}px` } : {}),
        ...(filled ? { fontVariationSettings: "'FILL' 1, 'wght' 200, 'GRAD' 0, 'opsz' 48" } : {}),
      }}
    >
      {name}
    </span>
  );
}
